import BaseModule from './BaseModule'

class ConditionalTarget extends BaseModule {
	constructor(o) {
		super(o);

		// A radio fires `change` only when it becomes checked, never when it is
		// deselected, so listen at form level: picking a sibling option has to
		// clear this option's constraint too.
		this.addEvents([$(this.el.form), 'change', 'sync'])

		this.enable();
	}

	enable() {
		super.enable()

		this.sync()
	}

	// Mirrors the conditional `required` rule in ExpressionOfInterestRequest,
	// which applies only while this option is the selected one.
	sync() {
		const target = document.getElementById(this.$el.data('target'))

		if (target) {
			target.required = this.el.checked
		}
	}
}

export default ConditionalTarget